 $(document).ready(function(){
 	if(typeof APP_ENV !== 'undefined' && APP_ENV == 'production-dis'){
       $(document).bind("contextmenu",function(e){
              return false;
       });
    }

    //$('#tabs-common li:last-child a').tab('show');

    $(document).on("click", ".action-btn-sup", function(e) {

        let act = $(this).data('action');
        //alert(act);

        if(!confirm('Are you sure you want to ' + act + ' this duty?')){
            e.preventDefault();
            return false;
        }

        $('#form_action').val(act);

    });

    $(document).on("change", ".filter-field" , function() {
        //var i = 0;
        var urlStrArr = new Array();
        var i = 0;
        $( ".filter-field" ).each(function() {
            var eleId = $(this).attr('id');
            urlStrArr[i++] = eleId+"="+$(this).val();
        });

        var urlStr = '';
        if(urlStrArr.length){
            urlStr = "?"+urlStrArr.join("&");
        }
        //alert(urlStr);
        if(urlStr != "")
            window.location = urlStr;
    });

    
    $(document).on("click", ".copy-to-clip", function () {

        var selector = $(this).data('id');
        var input = document.querySelector(selector);

        if (!input) return;

        // If modern clipboard API is available (HTTPS)
        if (navigator.clipboard && window.isSecureContext) {

            navigator.clipboard.writeText(input.value).then(() => {
                showCopyMessage($(this));
            });

        } else {
            // Fallback for HTTP (local server)
            input.select();
            input.setSelectionRange(0, 99999);
            document.execCommand("copy");
            showCopyMessage($(this));
        }

    });

    function showCopyMessage(button) {
        var msg = button.closest('.row').find('.copyMsg');
        msg.show();

        setTimeout(function () {
            msg.hide();
        }, 2000);
    }


    $(document).on("click", ".scroll-btn" , function(e) {
       var eleId = $(this).attr('data-id');
       //alert(eleId);
       if (eleId === undefined)
                return true;
       var eleOffset = $(eleId).offset().top - parseInt(30);
       $('html, body').animate({
            scrollTop: eleOffset
        }, 800);

    });
 	    /*$('.datepicker').datepicker({
		    format: 'mm-dd-yyyy',
		});*/

	
		/*$('.dataTables-1').DataTable({
		  "pageLength": 50
		});*/

		/*if($(".dataTables-1").length){
	        window.loadDataTables();
	    }*/
    

       /* if($(".dataTables-print").length){
            window.loadDataTablesPrint();
        }*/


    $(document).on("submit", "form.ajax-submit" , function(e) {
         e.preventDefault();

         if($(this).hasClass('html-show') ){
            var htmlShow = true;
         }else{
            var htmlShow = false;
         }

        //$("#result-show").hide();
        $("label.error").remove();
        $('.error').removeClass('error');
        $('.response').hide().html("");

        var form = $(this).attr('id');

        Swal.fire({
            title: "Please Wait! ...",   
            text: "", 
            imageUrl: "/images/ajax-loader.gif",
            showCloseButton: false, 
            showCancelButton: false, 
            showConfirmButton: false
        });

        var formData =  new FormData(this);
        var formAction = $(this).attr('action');

        $.ajaxSetup({
            headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });
        
        $.ajax({
            url: formAction,
            method: 'POST',
            data: formData,
            cache:false,
            processData: false,
            contentType: false,
            dataType: "json",
            success: function(data){
                if(data.errors){
                    var errorHtml = '<ul class="alert-danger sweet-alert-error">';
                    $.each(data.errors, function(key, value){
                         errorHtml += "<li>"+value+"</li>";
                     });
                    errorHtml += "</ul>";

                    $('.response').show().append(errorHtml);

                    swal.fire({  
                        title: "Error! ...",   
                        html: errorHtml ,   
                        type: "error",   
                        confirmButtonText: "Close",
                        focusConfirm:true 
                    }
                    ,function(isConfirm) {

                    }
                    );
                }else{

                    if(data.redirect_url){
                        window.location = data.redirect_url;
                        return false;
                    }
                    //console.log(data);
                    if(htmlShow){
                        if(data.modal && data.modal == 1){
                            $(".modal-dialog").find("#output-page-modal").show().html(data.html);
                            $(".modal-dialog").find("#form-wrapper-modal").hide();
                        }else{
                            $("#output-page").show().html(data.html);
                            $("#form-wrapper").hide();
                            
                            $('html, body').animate({
                                scrollTop: $("#output-page").offset().top - 200
                            }, 600);
                        }

                        swal.close();

                    }else{
                        //alert("data.msg");
                        
                        swal.fire({  
                            title: "Success! ...",   
                            html: data.msg ,   
                            type: "success",   
                            confirmButtonText: "Close",
                            focusConfirm:true 

                        }
                        ,function(isConfirm) {
                            receiptModel.modal({show:false,backdrop: 'static',keyboard: false});
                        }
                        );
                    }
                    //swal.close();

                    
                }
            },
            error: function(e) {
                console.log(e);

                swal.fire({  
                    title: "Error! ...",   
                    html: "Refresh the page and try again" ,   
                    type: "error",   
                    confirmButtonText: "Close",
                    focusConfirm:true 
                    }
                    ,function(isConfirm) {}
                  );
            }
        });

        return false;
    });

    $(document).on("click", "#ajax-back-btn" , function() {
       $("#output-page").hide();
       $("#form-wrapper").show();

       $("form.ajax-submit").trigger("reset");

    });

    $(document).on("click", "#ajax-edit-btn" , function() {
       $("#output-page").hide().html('');
       $("#form-wrapper").show();

    });


    $(document).on("click", ".btn-url" , function(e) {
        var url = $(this).attr("data-href");
        var target = $(this).attr("data-target");

        if(target == '_blank'){
            var win = window.open(url, '_blank');
            win.focus();
            return false;
        }
        window.location = url;
        return false;
    });

       // Modal js for promotion cards

    $(document).on("click", ".open-modal-btn" , function() {
        var ele = this;
        var url = $(ele).attr('data-href');
        var modalId = $(ele).attr('data-modal-id');

        //alert(modalId);
        var modeltoOpen = $(modalId);
        /*$('.modal-body').load(dataURL,function(){
            $('#myModal').modal({show:true});
        });*/

        //window.displayDivLoader(ele);

        //var deposit_date = $("deposit_date").val();

        Swal.fire({
            title: "Please Wait! ...",   
            text: "", 
            imageUrl: "/images/ajax-loader.gif",
            showCloseButton: false, 
            showCancelButton: false, 
            showConfirmButton: false
        });

        $.ajax({
            url: url,
            method: 'GET',
            data: "",
            cache:false,
            processData: false,
            contentType: false,
            dataType: "json",
            success: function(data){

                if(data.success){
                    //window.loadActBtnPlugins();
                    modeltoOpen.find(".modal-title").html(data.title);
                    modeltoOpen.find(".modal-body").html(data.html);

                    //alert(data.title);

                    modeltoOpen.modal({show:true,backdrop: 'static',keyboard: false});

                    swal.close();
                    //window.loadFormPlugins(modalId);
                }else{
                   swal.fire({  
                    title: "Error! ...",   
                    html: unexpectedError ,   
                    type: "error",   
                    confirmButtonText: "Close",
                    focusConfirm:true 
                }
                ,function(isConfirm) {

                }
                );
               }
           },
           error: function(e) {
                console.log(e);

                swal.fire({  
                    title: "Error! ...",   
                    html: "Refresh the page and try again" ,   
                    type: "error",   
                    confirmButtonText: "Close",
                    focusConfirm:true 
                    }
                    ,function(isConfirm) {}
                  );
            }
        });
    });
	
 });

 /*window.loadDataTables = function(){
 	if ( $.isFunction($.fn.DataTable) ) {
        $('.dataTables-1').DataTable({
            pageLength: 50,
            responsive: false,
            dom: '<"html5buttons"B>lTfgitp',
            buttons:[],
            buttons: [
                {extend: 'copy'},
                {extend: 'csv'},
                {extend: 'excel', title: 'ExampleFile'},
                {extend: 'pdf', title: 'ExampleFile'},

                {extend: 'print',
                customize: function (win){
                        $(win.document.body).addClass('white-bg');
                        $(win.document.body).css('font-size', '10px');

                        $(win.document.body).find('table')
                            .addClass('compact')
                            .css('font-size', 'inherit');
                    }
                }
            ]

        });
    }/*else {
        document.writeln('DataTable does not exist');
	}*
    /*$('.dataTables-1').DataTable({
	  "pageLength": 50
	});*
   }*/


   /*window.loadDataTablesPrint = function(){
    if ( $.isFunction($.fn.DataTable) ) {
        $('.dataTables-print').DataTable({
            pageLength: 50,
            responsive: false,
            "aaSorting": [],
            dom: '<"html5buttons"B>lTfgitp',
            buttons: [
                'copyHtml5',
                'excelHtml5',
                //'csvHtml5',
                'pdfHtml5',
                'print'
            ]

        });
    }/*else {
        document.writeln('DataTable does not exist');
    }*
    /*$('.dataTables-1').DataTable({
      "pageLength": 50
    });*
   }*/
